<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-w-1/4 sm:m-0 m-4" >
      <vx-card class="login-principal box">
        <div slot="no-body" class="full-page-bg-color login-principal box2">

          <div class="vx-row no-gutter justify-center items-center login-principal">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg login-principal" >
              <div class="p-8 login-tabs-container">

                <div>
                  <img src="@/assets/images/logo/logo-agrotrack-icon.png" class="center" alt="Logo">
                </div>

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">AgroTrack</h4>
                  <p>Ouvrez une session pour commencer à utiliser l'application.</p>
                </div>

                <div>
                  <vs-input
                  style="border-radius: 50%"
                      :danger="error.username || verificationusername"
                      name="username"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Nom d'utilisateur"
                      v-model="username"
                      class="w-full"/>
                  
                  <span v-if="verificationusername || error.username" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    <p style="margin-bottom: 4px !important; font-size: 13px">{{verificationusername ? 'Le nom d\'utilisateur est réquis.' : 'Nom d\'utilisateur ou Mot de passe incorrect.'}}</p>
                  </span>

                  <vs-input
                      :danger="error.password || verificationpassword"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Mot de passe"
                      v-model="password"
                      class="w-full mt-6" />
                  
                  <span v-if="verificationpassword || error.password" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    <p style="margin-bottom: 4px !important; font-size: 13px">{{verificationpassword ? 'Le mot de passe est réquis.' : 'Nom d\'utilisateur ou Mot de passe incorrect.'}}</p>
                  </span>

                  <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Se souvenir de moi</vs-checkbox>
                      <router-link to="/auth/password-reset">Mot de passe oublié?</router-link>
                  </div>
                  <vs-button class="float-right mb-8 w-full" :disabled="!validateForm" @click="loginUserName()">Connexion</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
let base_self;

export default{
  data() {
    return {
      error: {
        username: false,
        password: false
      },
      username: "",
      username1: "",
      password: "",
      password1: "",
      // username: "admin", //
      // password: "agrotrack",  // 
      checkbox_remember_me: false,
      verificationpassword: false,
      verificationusername: false
    }
  },
  watch: {
    username () {
      if (base_self.username !== base_self.username1) {
        if (!base_self.username || base_self.username === '') {
          base_self.verificationusername = true
        } else {
          base_self.verificationusername = false
        }

        base_self.username1 = JSON.parse(JSON.stringify(base_self.username));
      }
    },
    password () {
      if (base_self.password !== base_self.password1) {
        if (!base_self.password || base_self.password === '') {
          base_self.verificationpassword = true
        } else {
          base_self.verificationpassword = false
        }

        base_self.password1 = JSON.parse(JSON.stringify(base_self.password));
      }
    }
  },
  computed: {
    validateForm() {
      return base_self.username !== '' && base_self.password.length >= 0;
    }
  },
  methods: {
    loginUserName() {
      let params = { username: base_self.username, password: base_self.password };
      base_self.$store.state.login_Online(params)
        .then((response) => {
          this.$vs.loading()
          localStorage.setItem('response_data_user_role', response.data.user.role);
          /* console.log(' ............................................................. response_data_user_role: sortie login');
          console.log(' ............................................................. response_data_user_role: sortie login');
          console.log(' ............................................................. response_data_user_role: sortie login');
          console.log(' ............................................................. response_data_user_role: sortie login');
          console.log(' ............................................................. response_data_user_role: sortie login');
          console.log(' ............................................................. response_data_user_role: sortie login');
          console.log(' ............................................................. response_data_user_role: sortie login'); */

          // console.log('response.data -----------: ', response.data.user.role);
          /* if (response.data.status) {
           
            console.log('response.data: ', response.data);
            window.getAgroTrack.success('Connexion avec succès', response);
          } else {
            base_self.error.username = true;
            base_self.error.password = true;
            // window.getAgroTrack.error(response.data);
          } */
          base_self.$store.dispatch('updateUserInfo', response.data)
            .then(() => { 
              base_self.$vs.loading.close()
              base_self.$router.push('/dashboard').catch(() => {})
            })
            .catch(error => {
              base_self.$vs.loading.close()
              base_self.$vs.notify({
                title: 'Erreur',
                text: error.response.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          // base_self.$store.dispatch('updateUserInfo', response.data);
          // base_self.$router.push('/dashboard')

          /* let routeData = base_self.$router.resolve({name: 'dashboard'});
          window.open(routeData.href, '_blank'); */
        })
        .catch((error) => {
          base_self.error.username = true;
          base_self.error.password = true;
          console.log('error: ', error)
        });
    }
  },
  async created() {
    base_self = this;
  }
}
</script>

<style>

.center {
  /* display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%; */
  height: 100px; 
  width: 100px;
}

.login-principal {
  /* border: 2px solid red; */
  border-radius: 20px;
}

.leger {
  /* On ne voit presque pas le texte */
  opacity: 0.2;
}
.moyen {
  /* On peut mieux discerner le texte */
  opacity: 0.5;
}
.lourd {
  /* Le texte est clairement visible */
  opacity: 0.9;
}

.background {
  padding: 20px;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;    
}

.box {
  /* position: relative;
  max-width: 600px; */
  /* opacity: 0.2; */
  background: rgba(255,255,255,.2);
  /* background-color: rgba(90, 125, 0, 0.5);
  box-shadow: 0 5px 15px rgba(0,0,0,.5); */
}

.box2 {
  font-size: 18px;
  font-weight: 100;
  color: black;
}

</style>